<template>
  <div class="loading-indicator" data-test-id="loading-indicator">
    <LoadIcon v-if="size === 'large'" class="loading-indicator__animation" />
    <LoadIcon16 v-else class="loading-indicator__animation" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LoadIcon from '@components/Icons/LoadIcon.vue';
import LoadIcon16 from '@components/Icons/LoadIcon16.vue';

export default defineComponent({
  name: 'LoadingIndicator',

  components: {
    LoadIcon,
    LoadIcon16,
  },

  props: {
    size: {
      type: String,
      default: 'medium',
      validator(value) {
        return ['medium', 'large'].indexOf(value) !== -1;
      },
    },
  },
});
</script>

<style lang="scss">
@keyframes load-spinner {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  // Force display in Btn component
  overflow: visible;
  min-width: auto;
}

.loading-indicator__animation {
  animation: load-spinner 0.7s infinite linear;
}
</style>
